module.exports = __webpack_public_path__ + "static/media/8.7b1cda08.jpeg";